export const articleAttributesNL = {
  'Color Case': 'Kleur kast',
  'Color Dial': 'Kleur wijzerplaat',
  'Color Strap': 'Kleur band',
  'Case Thickness': 'Kast dikte',
  'Water Resistant': 'Waterdichtheid',
  Gender: 'Geslacht',
  'Material Case': 'Materiaal kast',
  'Material Strap': 'Materiaal band',
  Movement: 'Uurwerk',
  'Time Display': 'Tijdsaanduiding/functie',
  'Time Display/function': 'Tijdsaanduiding/functie',
  'Time display/function': 'Tijdsaanduiding/functie',
  'Type Clasp': 'Sluiting',
  'With Diamond(s)': 'Met diamant',
  Material: 'Materiaal',
  'With Diamond': 'Met diamant',
  'Type Jewel': 'Type juweel',
  'Diamond description': 'Diamant beschrijving',
  'Omschrijving Diamond(s)': 'Diamant omschrijving',
  'Metal grade': 'Metaalgehalte',
  'Total Stones': 'Totaal stenen',
  'Carat Diamond(s)': 'Karaat diamant(en)',
  'Carat Diamond': 'Karaat diamant',
  'Color Stone Description': 'Kleursteen beschrijving',
  'Total Color Stones': 'Totaal aantal kleurstenen',
  'Carat Color Stone': 'Karaat kleurstenen',
  Clarity: 'Helderheid',
  Color: 'Kleur',
  Year: 'Jaar',
  Box: 'Doos',
  Papers: 'Papieren',
  Condition: 'Staat Horloges',
  Complication: 'Complicaties',
  'Diameter Case': 'Diameter Horlogekast',
  Dial: 'Wijzerplaat',
  Index: 'Uurmarkering',
  'Bezel Material': 'Materiaal Lunette',
  'Crystal	Glas': 'Type',
  'Material Bracelet': 'Materiaal Horlogeband',
  'Clasp	Type': 'Sluiting',
  'Unique Description': 'Unieke Omschrijving',
  'Power Reserve': 'Gangreserve',
  Price: 'Prijs',
  Crystal: 'Kristal',
  Clasp: 'Gesp',
  Caliber: 'Kaliber',
}
